import { styled } from 'twin.macro'
import Row from '../grid/row/Row'

export const ComponentManagerComponentRow = styled(Row)`
    padding: 3rem 0;
`
